app.service('TasksAPI', ['$http', 'ENV', 'Session', function($http, ENV, Session) {

	// Settings screens can edit a practice other than the one the session is on, so
	// the label/settings calls take an optional practice id. Everything that omits it
	// keeps hitting the session practice exactly as before.
	function resolvePracticeId(practiceId) {
		return practiceId || (Session.practice && Session.practice.id);
	}

	var service = {
		isProcessing: false,

		createTask: function (data) {
			return $http({
				method: "POST",
				url: ENV.API + "/api/task",
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
				data: { ...data },
			});
		},
		deleteTask: function (practiceId, taskId) {
			return $http({
				method: "DELETE",
				url: ENV.API + `/api/task/practice/${practiceId}/task/${taskId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
			});
		},
		// One task, in the same shape as an entry of the queryCreatedTasks/queryAssignedTasks lists, so a
		// single changed task can be refreshed without paging both of those lists again.
		getTask: function (practiceId, taskId) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/task/practice/${practiceId}/task/${taskId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
			});
		},
		updateTask: function (taskId, practiceId, data) {
			return $http({
				method: "PUT",
				url: ENV.API + `/api/task/practice/${practiceId}/task/${taskId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
				data: { ...data },
			});
		},
		addTaskLabel: function (data, _practiceId) {
			return $http({
				method: "POST",
				url: ENV.API + "/api/task/label",
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
				data,
			});
		},
		updateTaskLabel: function (id, data, _practiceId) {
			return $http({
				method: "PUT",
				url: ENV.API + `/api/task/label/${id}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
				data,
			});
		},
		queryTaskLabels: function (_practiceId) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/task/label`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
			});
		},
		queryCreatedTasks: function (startDateUTC, endDateUTC, pagination) {
			return $http({
				method: "POST",
				url: ENV.API + `/api/task/query?getOnlyUsersTasks=false&startDateUTC=${encodeURIComponent(startDateUTC)}&endDateUTC=${encodeURIComponent(endDateUTC)}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"Content-Type": "application/json",
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
				data: pagination
			});
		},
		queryAssignedTasks: function (startDateUTC, endDateUTC, pagination) {
			return $http({
				method: "POST",
				url: ENV.API + `/api/task/assigned?startDateUTC=${encodeURIComponent(startDateUTC)}&endDateUTC=${encodeURIComponent(endDateUTC)}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
				data: pagination,
			});
		},
		getUsers: function (_practiceId) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/users/task-users`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
			});
		},
		getTaskSetting: function (_practiceId) {
			const practiceId = resolvePracticeId(_practiceId);
			return $http({
				method: "GET",
				url: ENV.API + `/api/task/user/${Session.user.id}/settings?practiceId=${practiceId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
			});
		},
		updateTaskSetting: function (data, _practiceId) {
			const practiceId = resolvePracticeId(_practiceId);
			return $http({
				method: "POST",
				url: ENV.API + `/api/task/user/${Session.user.id}/settings?practiceId=${practiceId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
				data,
			});
		},
	};

	return service;
}])
